export default {"src":"/_next/static/media/mana9.240dded1.svg","height":600,"width":600,"blurWidth":0,"blurHeight":0};